import * as Sentry from '@sentry/vue'

export const ENABLE_SENTRY =
  !!process.env.MIX_APP_ENV && process.env.MIX_APP_ENV !== 'local'

export function logError(error) {
  if (ENABLE_SENTRY) {
    Sentry.captureException(error)
  } else {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}
